import React from 'react';
import styles from './UIGameCount.module.scss';
import clsx from 'clsx';
import { GameColor } from '../../utils/GameColor.ts';
export function UIGameCount({ className, count, color, size = 'base' }) {
    const backgroundColor = GameColor.getPlayerBGDarkHash(color);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className, styles[size]),
        style: {
            backgroundColor: backgroundColor
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.count, styles[size])
    }, count));
}
